module.exports = __webpack_public_path__ + "static/media/ky.6b63b595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ky.png
// module id = 1902
// module chunks = 0